"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUniqueDynoName = generateUniqueDynoName;
exports.deltaDynoConfigs = deltaDynoConfigs;
exports.errorIsBadRequest = errorIsBadRequest;
exports.getFieldForError = getFieldForError;
exports.getFieldsForSaveDraftError = getFieldsForSaveDraftError;
exports.calculateConversion = calculateConversion;
exports.getFooterInfoContentSettingsUrl = getFooterInfoContentSettingsUrl;
exports.getDefaultTriggers = getDefaultTriggers;
exports.getPrivacySettingsLink = getPrivacySettingsLink;
exports.getEmailDomain = getEmailDomain;
exports.getKickBackEmailsSubscriptionId = getKickBackEmailsSubscriptionId;
exports.getUsersRequiredAttributes = getUsersRequiredAttributes;
exports.getPortalDomain = getPortalDomain;
exports.getDynoStatus = getDynoStatus;
exports.getDynoPrimaryCTA = getDynoPrimaryCTA;

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

var _enviro = _interopRequireDefault(require("enviro"));

var PROHIBITED_DOMAINS = _interopRequireWildcard(require("lead-flows-ui/constants/ProhibitedDomains"));

var _Strings = require("lead-flows-ui/constants/Strings");

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _DynoErrorTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoErrorTypes"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

function generateUniqueDynoName() {
  return _Strings.DEFAULT_DYNO_NAME + " (" + _I18n.default.moment().format('LL LTS') + ")";
}

function deltaDynoConfigs(oldDyno, newDyno) {
  var delta = {};
  (0, _underscore.each)(Object.keys(oldDyno || {}), function (key) {
    if (oldDyno[key] !== newDyno[key]) {
      delta[key] = newDyno[key];
    }
  });

  if (oldDyno.formFields.length !== newDyno.formFields.length || delta.locale) {
    delta.formFields = newDyno.formFields;
  }

  return delta;
}

function errorIsBadRequest(error) {
  return error.status === 400 || error.status === 409;
}

function getFieldForError(errorResponse) {
  return _DynoErrorTypes.default[errorResponse.errorType];
}

function getFieldsForSaveDraftError(errorMessage) {
  var regExp = /\[(.*?)\]/;
  var fieldsSearch = regExp.exec(errorMessage);
  var fields = Array.isArray(fieldsSearch) && fieldsSearch[1].split(', ');
  return fields;
}

function calculateConversion(contacts, views) {
  var result;

  if (!contacts || !views) {
    result = 0;
  } else {
    var conversion = contacts / views * 10000;
    result = Math.ceil(conversion) / 100;
  }

  return result;
}

function getFooterInfoContentSettingsUrl() {
  var portalId = _hubspot.default.get();

  if (_enviro.default.getShort() === 'qa') {
    return "https://app.hubspotqa.com/settings/" + portalId + "/marketing/email/configuration";
  }

  return "https://app.hubspot.com/settings/" + portalId + "/marketing/email/configuration";
}

function getDefaultTriggers(dynoType) {
  switch (dynoType) {
    case _DynoTypes.default.POP_OVER:
      return {
        displayOnExitIntent: true,
        displayOnScroll: false,
        displayOnTimedDelay: 0
      };

    case _DynoTypes.default.BOTTOM_LEFT:
    case _DynoTypes.default.BOTTOM_RIGHT:
      return {
        displayOnExitIntent: false,
        displayOnScroll: true,
        displayOnTimedDelay: 0
      };

    case _DynoTypes.default.TOP:
      return {
        displayOnExitIntent: false,
        displayOnScroll: false,
        displayOnTimedDelay: 7000
      };

    case _DynoTypes.default.EMBEDDED:
      return {
        displayOnExitIntent: false,
        displayOnScroll: false,
        displayOnTimedDelay: 0
      };

    default:
      LOG.error("Could not get triggers for unknown type: " + dynoType);
      return {};
  }
}

function isEmailAddressPermitted(emailAddress) {
  return (0, _underscore.all)(PROHIBITED_DOMAINS, function (domain) {
    return emailAddress.indexOf(domain) === -1;
  });
}

function getPrivacySettingsLink() {
  var portalId = _hubspot.default.get();

  var env = _enviro.default.getShort() === 'qa' ? 'qa' : '';
  return "https://app.hubspot" + env + ".com/sales-products-settings/" + portalId + "/privacy";
}

function getEmailDomain(emailAddress) {
  return emailAddress.substring(emailAddress.indexOf('@') + 1);
}

function getKickBackEmailsSubscriptionId(dyno) {
  if (dyno.kickbackEmails && dyno.kickbackEmails.length > 0 && dyno.kickbackEmails[0].emailData) {
    return dyno.kickbackEmails[0].emailData.emailSubscriptionId;
  }

  return null;
}

function getUsersRequiredAttributes(users) {
  var emailSenders = [];

  for (var index in users) {
    if (users.hasOwnProperty(index)) {
      var emailAddress = users[index].email;
      var emailDomain = void 0;
      var status = 'warning';
      var helpText = 'notVerified';
      var permitted = true;

      if (!isEmailAddressPermitted(emailAddress)) {
        helpText = 'notPermitted';
        emailDomain = getEmailDomain(emailAddress);
        status = 'danger';
        permitted = false;
      } else if (users[index].verified === true) {
        status = 'success';
        helpText = 'verified';
      }

      emailSenders.push({
        name: _I18n.default.formatName({
          firstName: users[index].firstName,
          lastName: users[index].lastName
        }),
        address: emailAddress,
        value: index,
        verified: users[index].verified,
        helpText: helpText,
        emailDomain: emailDomain,
        status: status,
        permitted: permitted,
        id: users[index].id
      });
    }
  }

  return emailSenders;
}

function getPortalDomain(state) {
  return state.portal.domain;
}

function getDynoStatus(dyno) {
  var status;

  if (dyno.enabled) {
    status = 'published';
  } else if (dyno.scheduled) {
    status = 'scheduled';
  } else {
    status = 'draft';
  }

  return status;
}

function getDynoPrimaryCTA(dyno) {
  var enabled = dyno.enabled,
      scheduled = dyno.scheduled,
      publishAt = dyno.publishAt,
      unpublishAt = dyno.unpublishAt;
  var hasScheduling = Boolean(publishAt) || Boolean(unpublishAt);
  var primaryCTA;

  if (!enabled && hasScheduling) {
    primaryCTA = 'schedule';
  } else if (!enabled && scheduled && !hasScheduling) {
    primaryCTA = 'unschedule';
  } else if (!enabled && !scheduled && !hasScheduling) {
    primaryCTA = 'publish';
  } else {
    primaryCTA = 'update';
  }

  return primaryCTA;
}